module.exports = __webpack_public_path__ + "static/media/04.78233d11.png";